import SocialAnalyticsDashboard from './SocialAnalyticsDashboard';

export default SocialAnalyticsDashboard;
